<script>
  import { t } from 'precompile-intl-runtime';
  import { onMount } from 'svelte';
  import ui from 'stores/UI';
  import options from 'stores/Options';
  import draft from 'stores/Draft';
  import YarnSelector from 'components/YarnSelector/YarnSelector.svelte';
  import CheckboxInput from 'components/CheckboxInput/CheckboxInput';
  import { Dropdown, DropdownItem } from 'components/Dropdown';

  export let height = 0;
  export let sidebarOpen;
  $: cellSizeInput = $ui.cellSize;
  let toolbarContainer;
  $: toggleTreadleOrder = $options.showTreadleOrder;
  $: toggleThreading = $options.showThreading;
  $: {
    options.update((draft) => {
      draft.showTreadleOrder = toggleTreadleOrder;
    });
  }

  $: {
    options.update((draft) => {
      draft.showThreading = toggleThreading;
    });
  }

  onMount(() => {
    height = toolbarContainer.clientHeight;
  });

  /*
  function toggleTreadleOrder() {
    ui.update((draft) => {
      draft.showTreadleOrder = !draft.showTreadleOrder;
    });
  }

  function toggleThreading() {
    ui.update((draft) => {
      draft.showThreading = !draft.showThreading;
    });
  }
*/

  function toggle() {
    sidebarOpen = !sidebarOpen;
    if (sidebarOpen === false) {
      ui.update((temp) => {
        temp.selectedMenu = -1;
      });
    }
  }
</script>

<div class="tool-bar" bind:this={toolbarContainer}>
  <button class="hamberder" on:click={toggle}
    >{#if !sidebarOpen}≡{:else}x{/if}</button
  >

  <div>
    <button on:click={draft.undo}>{$t('terms.undo')}</button>
    <button on:click={draft.redo}>{$t('terms.redo')}</button>
  </div>

  <Dropdown>
    <DropdownItem>
      <CheckboxInput
        bind:checked={toggleThreading}
        label={$t('toolbar.showThreading')}
      />
    </DropdownItem>
    <DropdownItem>
      <CheckboxInput
        bind:checked={toggleTreadleOrder}
        label={$t('toolbar.showTreadleOrder')}
      />
    </DropdownItem>
  </Dropdown>
  <YarnSelector />
</div>

<style>
  .tool-bar {
    justify-content: space-between;
    display: flex;
    background-color: var(--color-1);
    pointer-events: all;

    grid-column: span 2;
    z-index: 10;
  }

  .hamberder {
    height: 100%;
    min-width: 2em;
  }
</style>
